import { AppState } from "../state/app.state";
import { Configuration } from '../../models/configuration';
import { createSelector } from '@ngrx/store';

const getConfigurationState = (state: AppState) => state.configuration;

export const selectConfiguration = createSelector(
	getConfigurationState,
	(state : Configuration) => state
);